(function(){
  var root = document.getElementById('th-cro-root');
  if(!root){ return; }
  var cfg = {
    max: parseInt(root.dataset.taksit||'3',10),
    note: root.dataset.taksitNot||'',
    days: parseInt(root.dataset.popGun||'14',10),
    delay: parseInt(root.dataset.popSure||'45',10)
  };
  function money(n){
    try{ return new Intl.NumberFormat('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(n)+' ₺'; }
    catch(e){ return n.toFixed(2)+' ₺'; }
  }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  /* TAKSİT TABLOSU
     r32 (27 Eki 2026): ölçü değişince tablo GÜNCELLENMİYORDU (Mert fark etti:
     200x300 seçili, fiyat 10.469 TL, tablo hala 1.519 TL). Eski kod data-amount
     niteliğinin değişmesini bekliyordu ama tema o niteliği hiç güncellemiyordu.
     Artık: varyant fiyatları kutunun data-prices niteliğinde (snippets/
     th-paytr-installments), seçili varyant üç yoldan izleniyor:
       1) Dawn'ın variant-change olayı (pubsub)
       2) ürün formundaki gizli id alanının 'change' olayı
       3) sayfa açılışında URL'deki ?variant= / formdaki id
     Bölüm yeniden çizilip kutu değişse bile her seferinde güncel kutu aranıyor. */
  function paint(box, cents){
    var amt = cents/100, out = '<div class="th-cro-taksit"><div class="th-cro-taksit__t">';
    for(var i=1;i<=cfg.max;i++){
      out += '<div class="th-cro-taksit__c'+(i===cfg.max?' is-best':'')+'">'
           + '<span class="th-cro-taksit__n">'+(i===1?'Tek çekim':(i+' taksit'))+'</span>'
           + '<span class="th-cro-taksit__p">'+money(amt/i)+'</span></div>';
    }
    out += '</div><p class="th-cro-taksit__f">'+esc(cfg.note)+'</p></div>';
    box.innerHTML = out;
    box.setAttribute('data-shown', String(cents));
  }
  function prices(box){
    if(box._p){ return box._p; }
    try{ box._p = JSON.parse(box.getAttribute('data-prices')||'{}'); }catch(e){ box._p = {}; }
    return box._p;
  }
  function currentId(){
    var inp = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if(inp && inp.value){ return String(inp.value); }
    try{ return new URLSearchParams(window.location.search).get('variant'); }catch(e){ return null; }
  }
  function sync(variant){
    var box = document.querySelector('[data-th-paytr]');
    if(!box){ return; }
    var id = variant && variant.id ? String(variant.id) : currentId();
    var cents = (variant && variant.price != null) ? variant.price : (id ? prices(box)[id] : null);
    if(cents == null){ cents = parseInt(box.getAttribute('data-amount')||'0',10); }
    if(!cents){ return; }
    if(id){ box.setAttribute('data-variant-id', id); }
    box.setAttribute('data-amount', String(cents));
    if(box.getAttribute('data-shown') !== String(cents) || !box.querySelector('.th-cro-taksit')){ paint(box, cents); }
  }
  function initTaksit(){
    if(!document.querySelector('[data-th-paytr]')){ return; }
    sync();
    try{
      if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
        subscribe(PUB_SUB_EVENTS.variantChange, function(e){
          var v = e && e.data && e.data.variant;
          setTimeout(function(){ sync(v); }, 0);
        });
      }
    }catch(e){}
    document.addEventListener('change', function(e){
      var t = e.target;
      if(t && (t.name === 'id' || t.closest && t.closest('variant-selects, variant-radios'))){ setTimeout(function(){ sync(); }, 60); }
    });
    window.addEventListener('popstate', function(){ sync(); });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',initTaksit); } else { initTaksit(); }

  var pop = document.getElementById('th-pop');
  if(!pop){ return; }
  var KEY='thPop';
  function seen(){ try{ var t=parseInt(localStorage.getItem(KEY)||'0',10); return !!t && (Date.now()-t) < cfg.days*864e5; }catch(e){ return false; } }
  function mark(){ try{ localStorage.setItem(KEY,String(Date.now())); }catch(e){} }
  function openPop(){ if(seen()||pop.classList.contains('is-open')){ return; } pop.classList.add('is-open'); mark(); }
  function closePop(){ pop.classList.remove('is-open'); }

  pop.addEventListener('click', function(e){ if(e.target===pop || e.target.hasAttribute('data-th-pop-close')){ closePop(); } });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closePop(); } });

  if(!seen()){
    var armed=false;
    setTimeout(function(){ armed=true; }, 8000);
    document.addEventListener('mouseout', function(e){ if(armed && !e.relatedTarget && e.clientY<=0){ openPop(); } });
    var last=window.scrollY, up=0;
    window.addEventListener('scroll', function(){
      if(!armed){ last=window.scrollY; return; }
      var y=window.scrollY;
      if(y<last){ up+=last-y; } else { up=0; }
      last=y;
      if(up>600 && y>400){ openPop(); }
    }, {passive:true});
    setTimeout(function(){ openPop(); }, cfg.delay*1000);
  }

  if(/customer_posted=true/.test(window.location.search)){
    var f=pop.querySelector('[data-th-pop-form]'), ok=pop.querySelector('[data-th-pop-ok]');
    if(f&&ok){ f.hidden=true; ok.hidden=false; pop.classList.add('is-open'); }
  }
})();
